import { DocPage } from "../components/DocPage";

export const ssr = { mode: "ssg" as const };

export default function Deployment() {
  return (
    <DocPage
      title="Deployment — Landrr.js"
      description="Deploy Landrr apps to Vercel, Railway, or GitHub Pages."
    >
      <h1>Deployment</h1>
      <h2>SSR hosts (Vercel, Railway, Render)</h2>
      <pre>
        <code>{`npm run build
npm run preview`}</code>
      </pre>
      <p>Runs <code>node server.js</code> in production.</p>
      <h2>GitHub Pages (SSG)</h2>
      <p>
        Add SSG routes, set <code>BASE_PATH</code> for project sites, then build:
      </p>
      <pre>
        <code>{`BASE_PATH=/landrr.js/ npm run build`}</code>
      </pre>
      <p>Deploy the <code>dist/client</code> folder.</p>
    </DocPage>
  );
}
